// Generated by genversion.
export const version = '8.1.1';
//# sourceMappingURL=version.js.map